export const COOKIE_NOTICE_TEXT =
  "🍪 powered by the privacy-focused GoSquared platform!";
